/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CachingInterceptor } from './cache-interceptor';
import { RBACInterceptor } from './rbac-interceptor';
import { CitywireInternalAccountsInteceptor } from '@tpapa/citywire-internal-accounts-angular';

/** Http interceptor providers in outside-in order */
export const HttpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CitywireInternalAccountsInteceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: RBACInterceptor, multi: true },
];
